import React from 'react'
import IconMail from '../../../../components/icon/IconMail'
import ReactQuill from 'react-quill'
import IconDevis from '../../../../components/icon/iconDevis'
import IconSendMail from '../../../../components/icon/IconSendMail'

const API_URL = process.env.REACT_APP_API_URL
const pot_url = `${API_URL}/photos/POT/`
const piece_jointe_supplementaire_url = `${API_URL}/uploads/pieceJointeSupplemantaire/`

const EmailFormSuggestion = (props) => {
  const {filename, objet, message, imagesPOT, pieceJointeSupplementaire, handleDownloadPdf} = props

  // Suppression du contenu de l'élément table (quill)
  const removeTables = (html: string) => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    doc.querySelectorAll('table').forEach((table) => table.remove())

    return doc.body.innerHTML
  }

  return (
    <div className={'border border-muted rounded-1 p-9 card'} id='hide-on-print'>
      <div className='mb-10'>
        <div className='d-flex gap-2 align-items-center'>
          <IconMail />
          <span className='mr-2 fs-3'>Message</span>
        </div>
      </div>
      <form>
        <div className='mb-6'>
          <label className='form-label'>Objet</label>
          <div style={{fontSize: '13px'}} className='form-control'>
            {objet}
          </div>
        </div>
        <div className='mb-6'>
          <label className='form-label'>Message</label>
          <div
            className={`form-control`}
            dangerouslySetInnerHTML={{
              __html: removeTables(message),
            }}
          >
            {/*{message}*/}
          </div>
        </div>

        {/* debut pièce jointe pdf */}
        <div
          className={
            'd-flex flex-column p-9 border border-muted rounded-2 my-6 bg-light-info border-info'
          }
        >
          <span className={'text-gray-700 mb-3'}>Pièce jointe</span>
          <div className='d-flex align-items-center gap-3 mb-3'>
            <div className='m-2'>
              <div
                className='d-flex align-items-center justify-content-center rounded-1 bg-white'
                style={{
                  width: '35px',
                  height: '35px',
                  flexShrink: 0,
                }}
              >
                <IconDevis size={22} color='#009ef7' />
              </div>
            </div>
            <div className='text-info'>{filename}</div>
          </div>

          {/* Affichage des images POTs*/}
          {/*{(imagesPOT?.length > 0) && <span className='text-gray-700 mb-3'>Pièce jointe image POT</span>}*/}

          {imagesPOT?.length > 0 && (
            <div className=''>
              {imagesPOT.map((image, index) => (
                <div
                  className='d-flex align-items-center gap-2 mt-1 text-info'
                  key={`${image}-${index}`}
                >
                  <img
                    src={`${pot_url}${image}`}
                    alt={image}
                    className='image-thumbnail rounded-1'
                    width='50'
                    height='50'
                  />
                  <button
                    type='button'
                    onClick={() => handleDownloadPdf(image, false)}
                    style={{
                      cursor: 'pointer',
                      color: '#009ef7',
                      textDecoration: 'none',
                      border: 'none',
                      background: 'none',
                      padding: 0,
                      textAlign:'left',
                    }}
                  >
                    {image}
                  </button>
                </div>
              ))}
            </div>
          )}

          {pieceJointeSupplementaire?.length > 0 && (
            <span className='text-gray-700 mb-3 mt-3'>Pièce jointe supplémentaire</span>
          )}

          {pieceJointeSupplementaire?.length > 0 &&
            pieceJointeSupplementaire.map((item: any, key) => (
              <div>
                <div key={key} className='d-flex align-items-center gap-2 mt-1 text-info'>
                  {['.png', '.jpg', '.jpeg'].some((ext) => (item?.name ?? item)?.includes(ext)) ? (
                    <img
                      src={`${
                        item?.name
                          ? URL.createObjectURL(item)
                          : `${piece_jointe_supplementaire_url}${item}`
                      }`}
                      alt={item?.name ?? item}
                      className='image-thumbnail rounded-1'
                      width='50'
                      height='50'
                    />
                  ) : (
                    <IconDevis size={20} color='#009ef7' />
                  )}
                  <span>{item?.name ?? item}</span>
                </div>
              </div>
            ))}
        </div>
      </form>
    </div>
  )
}

export default EmailFormSuggestion